import { useState, useEffect } from "react";
import axios from "axios";
import { verifyTokenExpire } from "middleware/verifyToken";
import { ToastBottomEnd } from "views/components/Toast";
import {
  toastEditSuccessMessageConfig,
  toastErrorMessageWithParameterConfig,
} from "config/toastConfig";
import { verifyPermission } from "helpers/permission";

export const useQuotaForm = (initialData, endpoint, userPermissions, t) => {
  const [quotas, setQuotas] = useState({});
  const [quotasErrors] = useState({
    unite: "",
    staff: "",
    traitement: "",
    validation: "",
    satisfaction: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateQuota = (field, value) => {
    setQuotas((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!verifyTokenExpire()) return;

    const data = {
      assignment_unit: quotas.unite,
      assignment_staff: quotas.staff,
      assignment_treatment: quotas.traitement,
      assignment_validation: quotas.validation,
      assignment_measure_satisfaction: quotas.satisfaction,
    };

    try {
      setIsSubmitting(true);
      await axios.put(endpoint.update, data);
      ToastBottomEnd.fire(toastEditSuccessMessageConfig());
    } catch (error) {
      if (
        !verifyPermission(userPermissions, "show-configuration-quota-delay") ||
        !verifyPermission(userPermissions, "update-configuration-quota-delay")
      ) {
        ToastBottomEnd.fire(
          toastErrorMessageWithParameterConfig(t("can_not_authorize"))
        );
      } else if (error?.response?.data?.error) {
        ToastBottomEnd.fire(toastErrorMessageWithParameterConfig(error.response.data.error));
      }else{
        console.log("Something is wrong", error);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if(initialData){
      setQuotas(initialData);
    }
  }, [initialData]);

  return {
    quotas,
    quotasErrors,
    isSubmitting,
    updateQuota,
    handleSave,
  };
};
